import { Button } from 'antd'
import { useLogout } from 'features/auth/hooks'
import React, { FC } from 'react'

import { LogoutIcon } from 'components/Icons'

const LogoutButton: FC = () => {
  const {
    fn: logout,
    state: { isLoading },
  } = useLogout()

  return (
    <Button
      data-testid='btn-logout'
      icon={<LogoutIcon $size='large' />}
      onClick={logout}
      loading={isLoading}
    />
  )
}

export default LogoutButton
